module.exports = __webpack_public_path__ + "img/star.dfb096bc.svg";